import React from "react";
import PropTypes from "prop-types";
import ToolTip from "./Tooltip";

function Button(Props) {
  const { type, placement = 'bottom', title, handleClick, disabled,className,form,id, toolTipMessage = "" } = Props;
  return (
    <button
      type={type}
      className={
        className
          ? className
          : !disabled
          ? "custom_button"
          : "custom_button disabled"
      }
      onClick={handleClick}
      disabled={disabled}
      form={form}
      id={id}
    >
      {
        toolTipMessage ? (
          <ToolTip placement={placement} toolTipMessage={toolTipMessage}>
            <span>{title}</span>
          </ToolTip>
        ) : title
      }
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
  form:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
  id:PropTypes.string
};

Button.defaultProps = {
  type: "button",
  title: "Please enter Button Title",
  handleClick: () => null,
  disabled: false,
  form:null,
  id:''
};

export default Button;
